import * as React from "react"
import { Flex } from "@chakra-ui/react"
import styled from "@emotion/styled"
import { HiVolumeOff } from "react-icons/hi"
import { RoomBranding } from "../../../recoil/atoms/room/types"
import useOnClickWithTouchHandler from "../../../hooks/useOnClickWithTouchHandler"

export interface StylesProps {
  roomStyles?: RoomBranding
  showLeaveOverlay?: boolean
}

export const Button = styled.button<StylesProps>`
  position: absolute;
  z-index: 10000000;
  top: ${({ showLeaveOverlay }) =>
    showLeaveOverlay ? "calc(50% + 0px)" : "50%"};
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  padding: 10px;
`

export const BigUnMuteIcon = styled(HiVolumeOff)`
  color: white;
  font-size: 3rem;
  transform: translate(5%, 0%);
`

const _BigUnMuteButton = ({
  height,
  width,
  enabled,
  handlePlay,
  showLeaveOverlay,
}): JSX.Element => {
  const handleCallback = useOnClickWithTouchHandler(handlePlay)

  if (!enabled) {
    return null
  }
  return (
    <Flex
      background="rgba(255,255,255,0.4)"
      id="play-button"
      width={width ?? "100%"}
      height={height ?? "100%"}
      position="absolute"
      zIndex={1000000000}
      left="50%"
      transform="translate(-50%)"
      {...handleCallback}
    >
      <Button showLeaveOverlay={showLeaveOverlay}>
        <BigUnMuteIcon />
      </Button>
    </Flex>
  )
}

export const BigUnMuteButton = React.memo(_BigUnMuteButton)
